/**
 * SSPS Product Sticky Add to Cart Handler
 * Robust null-guarded scroll observer and variant synchronizer
 */
(function() {
  if (!customElements.get("sticky-variant-select")) {
    class StickyProVariantSelect extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onStickyVariantChange);
      }

      onStickyVariantChange() {
        var select = this.querySelector("select");
        if (!select) return;
        var sectionId = this.dataset.section;
        var productForm = document.querySelector("#product-sticky-form-" + sectionId);
        if (productForm) {
          var input = productForm.querySelector('input[name="id"]');
          if (input) input.value = select.value;
        }
      }
    }
    customElements.define("sticky-variant-select", StickyProVariantSelect);
  }

  function initStickyCart() {
    var productStickyWrapper = document.querySelector(".product__sticky");
    var buyButtonForm = document.querySelector(".product_buy_button_form, form[action*='/cart/add']");

    if (!productStickyWrapper) return;

    var stickySelectedVariant = document.querySelector("#sticky__variant");
    var stickySelectVariantInput = document.querySelector("#sticky__selected_variant_id");
    if (stickySelectedVariant && stickySelectVariantInput) {
      stickySelectVariantInput.value = stickySelectedVariant.value;
    }

    // Sync variant ID and price from main product form to sticky cart form
    function syncMainVariantToSticky() {
      var mainVariantInput = document.querySelector("input[name='id'][form*='product-form'], .product_buy_button_form input[name='id']");
      if (mainVariantInput && mainVariantInput.value) {
        if (stickySelectVariantInput) stickySelectVariantInput.value = mainVariantInput.value;
        if (stickySelectedVariant && stickySelectedVariant.value !== mainVariantInput.value) {
          stickySelectedVariant.value = mainVariantInput.value;
        }
      }
      var mainPrice = document.querySelector(".price .price-item--last, .price .price-item--sale, .price .price-item--regular");
      var stickyPrice = document.querySelector(".product__sticky .sticky__product_price");
      if (mainPrice && stickyPrice && mainPrice.textContent.trim()) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
    }

    document.addEventListener("variant:change", syncMainVariantToSticky);
    document.addEventListener("change", function(e) {
      if (e.target && (e.target.matches("variant-radios input, variant-selects select, .product-form input[name='id']"))) {
        setTimeout(syncMainVariantToSticky, 50);
      }
    });

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          ticking = false;
          if (!productStickyWrapper) return;

          var target = buyButtonForm || document.querySelector(".product__info-wrapper") || document.querySelector(".product__title");
          if (!target) return;

          var rect = target.getBoundingClientRect();
          // Show sticky bar when the main buy button or product title has scrolled past viewport top
          if (rect.bottom < 50) {
            productStickyWrapper.classList.add("sticky");
            document.body.classList.add("sticky__cart");
          } else {
            productStickyWrapper.classList.remove("sticky");
            document.body.classList.remove("sticky__cart");
          }
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // initial check
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyCart);
  } else {
    initStickyCart();
  }
})();
